export default {
  label: {
    series: {
      engagedContacts: 'Contactos con interacción',
      nonEngagedContacts: 'Contactos que no respondieron',
    },
  },
};
